module.exports = __webpack_public_path__ + "images/restyling-c5acdfeb89a9d3c11e18d78c9e3ec016.svg";